import React, { useRef, useEffect, useState } from 'react';
import Editor from '@monaco-editor/react';

const MonacoEditor = ({
  value = '',
  language = 'javascript',
  theme = 'vs-dark',
  options = {},
  onChange = () => { },
  onMount = () => { },
  ...props
}) => {
  const editorRef = useRef(null);
  const prevValueRef = useRef(value);

  const [isDarkMode, setIsDarkMode] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  useEffect(() => {
    if (editorRef.current && value !== prevValueRef.current) {
      // Only update if the value has actually changed
      const currentValue = editorRef.current.getValue();
      if (currentValue !== value) {
        editorRef.current.setValue(value);
      }
      prevValueRef.current = value;
    }
  }, [value]);

  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
    onMount(editor);
  };

  const handleEditorChange = (newValue) => {
    // Only trigger onChange if the change wasn't caused by setValue
    if (newValue !== prevValueRef.current) {
      prevValueRef.current = newValue;
      onChange(newValue);
    }
  };

  return (
    <Editor
      height="100%"
      width="100%"
      value={value}
      language={language}
      theme={theme}
      isDarkMode={isDarkMode}
      wrapperClassName="w-full h-full p-2 pr-6 border rounded resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
      options={{
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        automaticLayout: true,
        ...options,
      }}
      onChange={handleEditorChange}
      onMount={handleEditorDidMount}
      {...props}
    />
  );
};

export default MonacoEditor;
